import { Injectable } from '@angular/core';
import { HttpInterceptorService } from '../_services/http-interceptor.service';

@Injectable()
export class UserService {
    constructor(private httpInterceptorService: HttpInterceptorService) { }

    login(userName: string, passWord: string) {
        return this.httpInterceptorService.request({
            method: 'GET',
            url: 'http://localhost:8130/OrderForm.svc/Sample?p1=userName&p2=passWord',
        });
    }
}